import { render, staticRenderFns } from "./ShippingAdd.vue?vue&type=template&id=4c728e04&scoped=true&"
import script from "./ShippingAdd.vue?vue&type=script&lang=js&"
export * from "./ShippingAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAdd.vue?vue&type=style&index=0&id=4c728e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c728e04",
  null
  
)

export default component.exports